import type { FC } from "react";
import { useTranslation } from "react-i18next";
import type { ThemeSlotPropsMap } from "@huub-web/ui/contexts/ThemeSlotContext";

import { FnvBanner } from "./FnvBanner";

type Props = ThemeSlotPropsMap["pageHeading"];

const PAGE_CONFIG: Record<
  string,
  { imageSrc: string; imagePosition?: string }
> = {
  advice: {
    imageSrc:
      "https://www.fnv.nl/getmedia/4d90c66a-c08a-4082-8108-d78378ce0fb9/bijeenkomsten-trainingen-fnv.jpg?type=16x9",
  },
  documentsOutgoing: {
    imageSrc:
      "https://www.fnv.nl/getmedia/14f087a5-c825-4b2a-83bb-05de1486046b/header-inkomensverklaring.jpg",
  },
  documentsIncoming: {
    imageSrc:
      "https://www.fnv.nl/getmedia/14f087a5-c825-4b2a-83bb-05de1486046b/header-inkomensverklaring.jpg",
  },
  interestRates: {
    imageSrc:
      "https://www.fnv.nl/getmedia/b6a8e03a-7653-45b2-bdd0-b10b6b48ae98/oudere-dame-achter-laptop-met-koffie.jpg?type=16x9",
  },
  maximumMortgage: {
    imageSrc:
      "https://www.fnv.nl/getmedia/572cdf13-7478-4926-833b-23680d5f8816/berekenen-header-2.png?type=header",
    imagePosition: "70% center",
  },
  orientation: {
    imageSrc:
      "https://www.fnv.nl/getmedia/c1dc60e7-fc59-4e8f-96a8-43a80d345c1f/header-woondiensten-1920x440.jpg?width=1920&height=800&ext=.jpg&dtime=20230123092454&type=header",
    imagePosition: "70% center",
  },
};

export const FnvPageHeading: FC<Props> = ({ scope }) => {
  const { t } = useTranslation();
  const config = PAGE_CONFIG[scope];

  return (
    <FnvBanner
      title={t(`${scope}Heading.title`)}
      description={t(`${scope}Heading.description`)}
      imageSrc={config?.imageSrc ?? ""}
      imagePosition={config?.imagePosition}
    />
  );
};
